module.exports = __webpack_public_path__ + "media/src/assets/Images/TicketIcon-bc5d27c46522170ace8782bc4183b6f8.svg";